import React from 'react';
import WelcomeImage from "./projectHeader.jpg";
import overlayImage from "../commonImg/overlay2-50.svg";
function Header() {
    const heroStyle={
        backgroundImage:`url(${WelcomeImage})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundAttachment:'initial'
    };
    const overlay={
        backgroundImage:`url(${overlayImage})`,
    };
    const headerStyle={
        textShadow:'1px 0 0 #fff, -2px 0 0 #fff, 0 2px 0 #fff, 0 -2px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff'
    };
    return(
        <header className="hero hero-fluid hero-page txt-color-sasha-darkest" style={heroStyle}>
            <div style={overlay}>
                <div className="container nfloat-down">
                    <h1 className="txt-weight-black" style={headerStyle}>Some of My Projects</h1>
                    <h5><span className="badge badge-sasha-darkest">Here I categorize some of my projects. Also you can check all...</span></h5>
                    <a className="btn btn-sasha-darkest-o" href="/projectList/all">All Projects</a>
                </div>
            </div>
        </header>
    )
}
export default Header;
